import { render, staticRenderFns } from "./close.vue?vue&type=template&id=8494a76c&scoped=true&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"
import style0 from "./close.vue?vue&type=style&index=0&id=8494a76c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8494a76c",
  null
  
)

export default component.exports